import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import i18n from '../utils/i18n';
import SimpleFormWrapper from '../components/SimpleFormWrapper';
import { validateEmail } from '../utils/other';
import ApiClient from '../utils/apiClient';
import { openModal } from '../actions/modalsActions';
import { modals, MIN_PASSWORD_LENGTH } from '../utils/constants';
import { getParams } from '../utils/other';

import './styles/PasswordContainer.scss';

class ResetPasswordContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      user: {
        password: '',
        repeatedPassword: ''
      },
      errors: {
        password: '',
        repeatedPassword: ''
      },
      backendError: '',
      confirmToken: ''
    };

    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  getTokenFromUrl() {
    const paramsString = this.props.location.search || '';
    const { confirmToken } = getParams(paramsString);

    this.setState({ confirmToken });
  }

  componentDidMount() {
    this.getTokenFromUrl();
  }

  handleChange(event) {
    const { name, value } = event.target;
    const { user, errors } = this.state;
    this.setState({
      user: {
        ...user,
        [name]: value
      },
      errors: {
        ...errors,
        [name]: false
      }
    });
  }

  handleSubmit(event) {
    event.preventDefault();

    const { password, repeatedPassword } = this.state.user;
    const errors = {};
    this.setState({ errors });

    if (password === '') {
      errors.password = i18n.t('resetPassword.PASSWORD_REQUIRED');
    } else if (password.length < MIN_PASSWORD_LENGTH) {
      errors.password = i18n.t('resetPassword.PASSWORD_MUST_HAVE_MINIMUM_EIGHT_CHARS');
    } else if (password !== repeatedPassword) {
      errors.repeatedPassword = i18n.t('resetPassword.PASSWORDS_ARE_DIFFERENT');
    }

    if (Object.keys(errors).length === 0) {
      ApiClient.post('/api/v1/user-profile-service/reset-password', {
        token: this.state.confirmToken,
        new_password: password
      })
        .then(() => {
          this.props.openModal(modals.CONFIRM_RESETTING_PASSWORD_SUCCESS, {});
        })
        .catch(() => {
          this.setState({
            backendError: i18n.t(
              'resetPassword.SOMETHING_WENT_WRONG'
            )
          });
        });
    } else {
      this.setState({ errors });
    }
  }

  render() {
    const { errors, user } = this.state;
    return (
      <div className="password-container">
        <SimpleFormWrapper
          onButtonClick={ this.handleSubmit }
          title={ i18n.t('resetPassword.CONFIRM_RESETING_PASSWORD') }
          buttonTitle={ i18n.t('resetPassword.RESET') }
          backendError={ this.state.backendError }
          leftButtonContent={ '' }
          showForgotPasswordLink={ false }
        >
          <div className="input-label">
            {i18n.t('resetPassword.PASSWORD')}
          </div>
          <input
            name="password"
            type="password"
            className={ `private-data form-control${
              errors.password ? ' is-invalid' : ''
            }` }
            placeholder={ i18n.t(
              'resetPassword.PASSWORD_PLACEHOLDER'
            ) }
            value={ user.password }
            onChange={ this.handleChange }
          />
          <div>
            {errors.password && (
              <div className="error">{errors.password}</div>
            )}
          </div>
          <div className="input-label second-label">
            {i18n.t('resetPassword.REPEATED_PASSWORD')}
          </div>
          <input
            name="repeatedPassword"
            type="password"
            className={ `private-data form-control${
              errors.repeatedPassword ? ' is-invalid' : ''
            }` }
            placeholder={ i18n.t(
              'forgotPassword.EMAIL_PLACEHOLDER'
            ) }
            value={ user.repeatedPassword }
            onChange={ this.handleChange }
          />
          <div>
            {errors.repeatedPassword && (
              <div className="error">{errors.repeatedPassword}</div>
            )}
          </div>
        </SimpleFormWrapper>
      </div>
    );
  }
}

ResetPasswordContainer.propTypes = {
  openModal: PropTypes.func.isRequired
}

const mapDispatchToProps = dispatch => ({
  openModal: (modal, modalData) => dispatch(openModal(modal, modalData))
});

export default withRouter(
  connect(
    null,
    mapDispatchToProps
  )(ResetPasswordContainer)
);



// WEBPACK FOOTER //
// ./src/containers/ResetPasswordContainer.js